import React from "react";
import { Alert } from "@material-ui/lab";
import { useDispatch, useSelector } from "react-redux";
import { Snackbar, ThemeProvider } from "@material-ui/core";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
// import Pages
import Login from "../pages/login";
import { MainDashboard } from "../pages/dashboard";
// import MainDashboard from "../MainDashboard";
import NoMatchPage from "../NoMatchPage";
// import LoginSuccessfulPage from "../LoginSuccessfulPage";
import ForgotPassword from "../pages/forgotPassword";

import { setAlert } from "../redux/reducers/alert";
import "./routes.css";
import PaymentFee from "../pages/paymentfee";
import PaymentLayer from "../pages/paymentLayer";
import { theme } from "../theme";
import PaymentLayerComponent from "../pages/paymentLayer/defaultPage/paymentLayer";
import PaymentDashboard from "../pages/paymentDashboard";
import NotificationForPaymentLink from "../pages/paymentDashboard/notificationForPaymentLinks";
import EventsPage from "../pages/events";
// import PaymentLayer from "../PaymentLayer";

const PublicRoutes = () => (
  <Switch>
    <Route path="/fee/:studentId" component={PaymentFee} />
    <Route path="/pl/receive" component={PaymentLayer} />
    <Route path="/pl" component={PaymentLayer} />
    <Route exact path="/" component={Login} />
    <Route path="/pl-receive" component={PaymentLayerComponent} />
    <Route path="/forgotPassword" exact component={ForgotPassword} />
    <Route path="/paymentLink/:schoolId" component={PaymentDashboard} />
    <Route path="/events/:id" component={EventsPage} />
    <Route path="/payment-receive" component={NotificationForPaymentLink} />
    <Route path="*" component={Login} />
  </Switch>
);

const AuthenticatedRoutes = () => (
  <Switch>
    <Route path="/events/:id" component={EventsPage} />
    <Route path="/paymentLink/:schoolId" component={PaymentDashboard} />
    <Route path="/payment-receive" component={NotificationForPaymentLink} />
    <Route path="/fee/:studentId" component={PaymentFee} />
    <Route path="/pl/receive" component={PaymentLayer} />
    <Route path="/pl" component={PaymentLayer} />
    <Route path="/" component={MainDashboard} />
    <Route path="*" component={NoMatchPage} />
  </Switch>
);
export const Routes = () => {
  const user = useSelector((state) => state.user);
  const { show, message, severity } = useSelector((state) => state.alert);

  const dispatch = useDispatch();

  const closeAlert = () => dispatch(setAlert({ show: false }));
  return (
    <Router>
      <ThemeProvider theme={theme}>
        <div className="app-container">
          {user ? <AuthenticatedRoutes /> : <PublicRoutes />}

          <Snackbar
            open={show}
            autoHideDuration={3000}
            onClose={closeAlert}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <Alert onClose={closeAlert} severity={severity}>
              {message}
            </Alert>
          </Snackbar>
        </div>
      </ThemeProvider>
    </Router>
  );
};
